import React, { useState } from "react";

export default function DateScroller({notifyDate}) {
    const [selected, setSelected] = useState(0);

function getDatesArray(days) {
    const arr = [];
    const today = new Date();
    for (let i = days - 1; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(today.getDate() - i);
        arr.push(d);
    }
    return arr;
}

  const days = 30;
  const dates = getDatesArray(days);

  function formatDay(date) {
    return date.getDate().toString().padStart(2, "0");
  }

  function formatMonth(date) {
    return date.toLocaleString("default", { month: "short" });
  }

  function isPast(date) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return date < now;
  }

  function isToday(date) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return date.getTime() === now.getTime();
  }

  
    return (
      <div style={{
        display: "flex",
        overflowX: "auto",
        gap: "24px",
        padding: "16px 0",
        marginBottom: "32px"
      }}>
        {dates.map((date, idx) => {
          let bg = "#333";
          let color = "#fff";
          if (isPast(date)) {
            bg = "#e0e0e0";
            color = "#888";
          }
          if (selected === idx) {
            bg = "#d41472";
            color = "#fff";
          }
          return (
            <div
              key={idx}
              onClick={() => !isPast(date) | setSelected(idx) | notifyDate(date)}
              style={{
                minWidth: 80,
                height: 140,
                borderRadius: 40,
                background: bg,
                color: color,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 28,
                transition: "background 0.2s, color 0.2s",
                boxShadow: selected === idx ? "0 4px 16px #d4147240" : undefined,
                outline: "none",
                border: "none",
                marginBottom: 8,
                userSelect: "none"
              }}
            >
              <span style={{ fontSize: 32 }}
            //   onClick={() => notifyDate(date)}
              >{formatDay(date)}</span>
              <span style={{
                fontSize: 18,
                fontWeight: 400,
                color: selected === idx ? "#fff" : (isPast(date) ? "#888" : "#ccc"),
                marginTop: 4
              }}
            //   onClick={() => notifyDate(date)}
              >
                {formatMonth(date)}
              </span>
            </div>
          );
        })}
      </div>
    );
  }
